<template>
  <div class="login-container select-exam">
    <i class="icon-logo"></i>
    <div class="login-wrap">
      <div class="pg"></div>
      <div class="select-main">
        <p class="common-tab">考试阅卷系统</p>
        <div class="select-warp">
          <el-select ref="examDom" class="select-action" v-model="selectId" placeholder="请选择试卷">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <button class="select-btn" @click="toJudge" :class="{'sure-disable': !selectId}">进入阅卷</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import { get } from '@/utils/ajax'
export default {
  components: {
    ElSelect: Select,
    ElOption: Option
  },
  data () {
    return {
      examList: [],
      selectId: null
    }
  },
  mounted () {
    this.getTagList()
  },
  methods: {
    toJudge () {
      if (!this.selectId) {
        this.$message.error('请选择试卷')
        return
      }
      const data = this.examList.find((item) => {
        if (item.id === this.selectId) {
          return item
        }
      })
      let routerName = 'judgeList'
      if (data.markingType === 1) {
        routerName = 'judgeExaminee'
      }
      this.$router.push({ name: routerName, query: { id: this.selectId, name: data.name, judgeId: data.judgeId } })
    },
    async getTagList () {
      const examList = await get(`/home/judges/markings`)
      this.examList = examList
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-logo {
  display: inline-block;
  width: 275px;
  height: 40px;
  margin: 20px 0 80px 80px;
}
.common-tab {
  text-align: center;
  margin: 127px auto 20px;
  color: $titleColor;
  font-size: 24px;
  font-weight: 500;
}
.select-warp {
  width: 360px;
  margin: 60px auto 0;
}
.space {
  display: inline-block;
  width: 20px;
}
.login-container {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #FAFAFA;
  .login-wrap {
    position: relative;
    display: flex;
    width: 1160px;
    height: 600px;
    border-radius: 8px;
    box-shadow: 0 10px 36px 0 rgba(48,111,255,0.15);
    margin: 0 auto 100px;
    overflow: hidden;
    &.monitor-login {
      box-shadow: 0 10px 36px 0 rgba(0, 0, 0, 0.06);
    }
  }
  .brand {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 20px;
    left: 0;
    font-size: 12px;
    font-weight: 300;
    color: #999;
  }
  .pg {
    width: 520px;
    height: 600px;
    background: url('~@/assets/images/login/login-bg-judge.png') no-repeat center / cover;
    box-shadow: 4px 4px 12px 0 rgba(48,111,255,0.4);
  }
  .monitor-bg {
    width: 520px;
    height: 600px;
    // background: url('~@/assets/images/monitor/login-bg.png') no-repeat center / cover;
    background: url('~@/assets/images/login/login-bg-judge.png') no-repeat center / cover;
    box-shadow: 0 10px 36px 0 rgba(0, 0, 0, 0.06);
  }
}
.login-wrap {
  .select-main {
    position: relative;
    background: #fff;
    flex: 1;
    border-radius: 0 8px 8px 0;
  }
  .select-btn {
    display: block;
    margin-top: 40px;
    @include theme-fill-btn(360px, 44px, 16px, 2px);
  }
  .sure-disable {
    @include theme-disable-btn(360px, 44px, 16px, 2px);
  }
}
</style>

<style lang="scss">
.select-exam {
  .el-select .el-input .el-select__caret {
    color: #666;
    font-size: 14px;
  }
  .select-action {
    .el-input__inner {
      width: 360px;
      height: 44px;
      border: 1px solid #DADADA;
      line-height: 44px;
      font-size: 14px;
    }
  }
}
</style>
